import { useState, useEffect, useRef } from 'react';
import { localizePath } from '../i18nRoutes';
import { Link, useNavigate } from 'react-router-dom';

export function Header({ language, t }) {
  const loc = (p) => localizePath(p, language);
  const [openDropdown, setOpenDropdown] = useState(null);
  const headerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (headerRef.current && !headerRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDropdownTrigger = (e, dropdownId, linkTo) => {
    if (openDropdown === dropdownId) {
      setOpenDropdown(null);
      navigate(linkTo);
    } else {
      e.preventDefault();
      setOpenDropdown(dropdownId);
    }
  };

  const handleDropdownItemClick = () => {
    setOpenDropdown(null);
  };

  return (
    <header className="header" ref={headerRef}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to={loc('/')}><img src="/images/viaturkey-logo.jpg" alt="Viaturkey Logo" /></Link>
          </div>
          <nav className="nav-menu">
            <a href="#about">{t.nav.about}</a>
            <div className={`nav-dropdown ${openDropdown === 'tours' ? 'dropdown-open' : ''}`}>
              <Link
                to={loc('/travel')}
                className="nav-dropdown-trigger"
                onClick={(e) => handleDropdownTrigger(e, 'tours', '/travel')}
                data-testid="nav-tours-trigger"
              >{t.nav.tours}</Link>
              <div className="nav-dropdown-menu" data-testid="tours-dropdown">
                <Link to={loc('/travel#tour-1')} onClick={handleDropdownItemClick}>{t.nav.tourDropdown.dayTours}</Link>
                <Link to={loc('/travel#tour-2')} onClick={handleDropdownItemClick}>{t.nav.tourDropdown.shoreExcursions}</Link>
                <Link to={loc('/travel#tour-4')} onClick={handleDropdownItemClick}>{t.nav.tourDropdown.foodTour}</Link>
                <Link to={loc('/travel#re-consulting')} onClick={handleDropdownItemClick}>{t.nav.tourDropdown.reConsulting}</Link>
                <Link to={loc('/travel#tour-3')} onClick={handleDropdownItemClick}>{t.nav.tourDropdown.layoverTour}</Link>
                <Link to={loc('/travel#medical-tourism')} onClick={handleDropdownItemClick}>{t.nav.tourDropdown.medicalTourism}</Link>
              </div>
            </div>
            <div className={`nav-dropdown ${openDropdown === 'realestate' ? 'dropdown-open' : ''}`}>
              <Link
                to={loc('/real-estate')}
                className="nav-dropdown-trigger"
                onClick={(e) => handleDropdownTrigger(e, 'realestate', '/real-estate')}
                data-testid="nav-realestate-trigger"
              >{t.nav.realEstate}</Link>
              <div className="nav-dropdown-menu" data-testid="realestate-dropdown">
                <Link to={loc('/real-estate#project-besiktas-luxury')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.besiktas}</Link>
                <Link to={loc('/real-estate#project-nivak-florya')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.florya}</Link>
                <Link to={loc('/real-estate#project-tual-golyaka-kanal')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.kanalIstanbul}</Link>
                <Link to={loc('/real-estate#project-skyland-prime')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.skyland}</Link>
                <Link to={loc('/real-estate#project-alya-merkezefendi')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.merkezefendi}</Link>
                <Link to={loc('/real-estate#project-tual-comfort-kanal-2')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.tualComfort}</Link>
                <Link to={loc('/real-estate#project-referans-beylikduzu')} onClick={handleDropdownItemClick}>{t.nav.realEstateDropdown.referansBeylikduzu}</Link>
              </div>
            </div>
            <a href={loc('/') + '#investment-insights'}>{t.nav.insights}</a>
            <a href="#contact">{t.nav.contact}</a>
          </nav>
        </div>
      </div>
    </header>
  );
}
